export const NOTICE_STATUS = {
    PENDING: 1,
    IN_PROGRESS: 2,
    AWAITING_JUSTIFICATION: 3,
    EUROFARMA_VALIDATION: 4,
    RESOLVED: 5,
    ARCHIVED: 6,
};

export const FINAL_STATUSES = [NOTICE_STATUS.RESOLVED, NOTICE_STATUS.ARCHIVED];

export const STATUS_COLORS = {
    [NOTICE_STATUS.PENDING]: "warning",
    [NOTICE_STATUS.IN_PROGRESS]: "info",
    [NOTICE_STATUS.AWAITING_JUSTIFICATION]: "secondary",
    [NOTICE_STATUS.EUROFARMA_VALIDATION]: "primary",
    [NOTICE_STATUS.RESOLVED]: "success",
    [NOTICE_STATUS.ARCHIVED]: "default",
};
